var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "parent_div" },
    [
      _c("dd-header"),
      _vm._v(" "),
      _c("h2", { staticClass: "hakotan_title" }, [_vm._v("搬入経路のご確認")]),
      _vm._v(" "),
      _c("div", { staticClass: "wrapper" }, [
        _c(
          "div",
          { staticClass: "main_content" },
          [
            _c("dd-menu", { ref: "menuRef" }),
            _vm._v(" "),
            _c("div", [
              _c("section", { staticClass: "guide_section" }, [
                _c("div", { staticClass: "guide_msg" }, [
                  _vm._v(
                    "\n            搬入の際に「廊下の天井に当たって運べない」「角を曲れない」などの家の構造や家具の大きさにより\n            目的の部屋まで搬入できない場合がございます。\n            事前に廊下の幅や天井までの高さなどのサイズや障害物がないか搬入経路のご確認のうえ、商品のご注文\n            をしてください。\n          "
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "route_item_area" }, [
                  _c("div", { staticClass: "step_text" }, [
                    _vm._v("①商品サイズを確認")
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "step_msg" }, [
                    _vm._v(
                      "\n              はじめに、家具サイズ（幅、高さ、奥行き）をご確認ください。そして「梱包サイズ」を考慮して、\n              家具サイズの天地左右＋100㎜以上の余裕を持って判断してください。 搬入にあたり、扉や廊下など\n              の通路には、家具の横幅以上の高さが必要です。また、搬入経路の幅は、家具の幅、高さ、奥行きの\n              うち一番短い寸法より大きい寸法でないと運べません。\n            "
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "route_img" }, [
                    _c("img", {
                      attrs: { src: _vm.getImage("guide/route_1.png") }
                    })
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "route_item_area" }, [
                  _c("div", { staticClass: "step_text" }, [
                    _vm._v("②搬入経路の確認箇所")
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "step_msg" }, [
                    _vm._v(
                      "\n              「玄関」「廊下」「階段」「エレベーター」「部屋の入口」の幅、高さ、奥行きをご確認ください。\n              また、ドアノブや照明など、障害物がないかもご確認ください。\n            "
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "route_img" }, [
                    _c("img", {
                      attrs: { src: _vm.getImage("guide/route_2.png") }
                    })
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "route_item_area" }, [
                  _c("div", { staticClass: "step_text" }, [
                    _vm._v("③エレベーターのサイズ確認")
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "step_msg" }, [
                    _vm._v(
                      "\n              家具をエレベーターに乗せるためには、入口と内部の大きさが家具より大きくなくてはいけません。\n              家具の幅、高さ、奥行きのうち、一番長い寸法が入口の高さより小さく、一番短い寸法が内部の奥行\n              より小さければエレベーターに乗せることができます。\n            "
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "route_img" }, [
                    _c("img", {
                      attrs: { src: _vm.getImage("guide/route_3.png") }
                    })
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "route_item_area" }, [
                  _c("div", { staticClass: "step_text" }, [
                    _vm._v("④階段のサイズ確認")
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "step_msg" }, [
                    _vm._v(
                      "\n              搬入で一番難しいのは階段です。特に踊り場では商品を立てられる高さが必要です。\n              「階段の幅・高さ」「踊り場の幅、高さ、奥行き」をご確認ください。\n            "
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", [
                    _c("div", { staticClass: "route_size_img" }, [
                      _c("div", [
                        _c("img", {
                          attrs: { src: _vm.getImage("guide/route_4-1.png") }
                        })
                      ]),
                      _vm._v(" "),
                      _c("div", [
                        _c("img", {
                          attrs: { src: _vm.getImage("guide/route_4-2.png") }
                        })
                      ])
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "route_item_area" }, [
                  _c("div", { staticClass: "route_entrance_size" }, [
                    _vm._m(0),
                    _vm._v(" "),
                    _c("div", [
                      _c("img", {
                        attrs: { src: _vm.getImage("guide/route_5-1.png") }
                      })
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "step_msg route_entrance" }, [
                    _vm._v(
                      "\n              玄関入り口では、特に以下の2点に注意しましょう。\n            "
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "entrance_item_area" }, [
                    _c("div", { staticClass: "entrace_item" }, [
                      _vm._m(1),
                      _vm._v(" "),
                      _c("div", [
                        _c("img", {
                          attrs: { src: _vm.getImage("guide/route_5-2.png") }
                        })
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "entrance_item_area" }, [
                    _c("div", { staticClass: "entrace_item" }, [
                      _vm._m(2),
                      _vm._v(" "),
                      _c("div", [
                        _c("img", {
                          attrs: { src: _vm.getImage("guide/route_5-3.png") }
                        })
                      ])
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "route_item_area" }, [
                  _c("div", { staticClass: "step_text" }, [
                    _vm._v("⑥室内廊下のサイズ確認")
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "step_msg" }, [
                    _vm._v(
                      "\n             「廊下の幅・天井までの高さ」「入り口の幅・高さ」「扉を開いた時のドアノブなどの突起物」「照明などの突起物」を確認してください。\n            "
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "route_img" }, [
                    _c("img", {
                      attrs: { src: _vm.getImage("guide/route_6-1.png") }
                    })
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "route_hall_area" }, [
                    _c("div", { staticClass: "route_hall_item" }, [
                      _vm._m(3),
                      _vm._v(" "),
                      _c("div", [
                        _c("img", {
                          attrs: { src: _vm.getImage("guide/route_6-2.png") }
                        })
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("dd-footer")
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("div", { staticClass: "step_text" }, [
        _vm._v("⑤玄関・共用通路のサイズ確認")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "step_msg" }, [
        _vm._v(
          "\n                  玄関と共用通路は玄関ドア周辺を確認してください。「廊下の幅・高さ」「玄関入口の幅・高さ」\n                  「玄関内部の幅・高さ・奥行き」が確保されていれば運ぶことができます。\n                  ドアノブや天井の照明なども考慮してください。\n                "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("div", { staticClass: "step_area_title" }, [
        _c("div"),
        _vm._v(" "),
        _c("div", [_vm._v("扉に引っかかる場合あります")])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "step_area_msg" }, [
        _vm._v(
          "\n                    家具を扉の前に運ぶと扉を開けることができず、扉を開けると家具が通らなくなる場合もありますので\n                    ご注意ください。\n                  "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("div", { staticClass: "step_area_title" }, [
        _c("div"),
        _vm._v(" "),
        _c("div", [_vm._v("家具が回転できない場合あります")])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "step_area_msg" }, [
        _vm._v(
          "\n                    扉を開くことができても、廊下の幅、入り口の幅が狭く搬入できない場合もありますのでご注意ください。\n                  "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("div", { staticClass: "step_area_title" }, [
        _c("div"),
        _vm._v(" "),
        _c("div", [_vm._v("曲り角の運び方")])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "step_area_msg" }, [
        _vm._v(
          "\n                    廊下に曲り角がある場合は、家具を縦にして回転させ搬入を行ってください。\n                    室内のドアノブ等の突起物などが搬入時に障害となるものにご注意ください。\n                  "
        )
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-92440616", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-92440616","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/main/js/hakotan/pages/DcRouteConfirm.vue
// module id = null
// module chunks = 